module.exports = __webpack_public_path__ + "img/msOutlook.f2aad8f4.svg";